import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import RichText from '@common/RichText';

import * as styles from '@styles/modules/careers.module.scss';

const UsersEmployeeCards = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        <Row className='row-cols-2 row-cols-lg-4 gy-3'>
          {list && list.map((user, index) => (
            <div key={index} className={styles.employeeCard} tabIndex={0}>
              {user.image &&
                <Img image={user.image.gatsbyImageData} file={user.image.file}/>
              }
              {user.review &&
                <div className={clsx(`flex-column align-items-start justify-content-end text-start mx-1 pop-in`, styles.employeeCardInfo, {[`bg-${user.bgColour}`]:user.bgColour})}>
                  <RichText p='d-none d-xl-block fs-16' json={user.review}/>
                  <span className={`fw-semibold`}>{`${user.name} ${user.pronouns}`}</span>
                  <span className={`text-uppercase`}>{user.title}</span>
                </div>
              }
            </div>
          ))}
        </Row>
      </Container>
    </Section>
  )
}

export default UsersEmployeeCards
